class PubSub {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    (this.events[event] || (this.events[event] = [])).push(callback);
  }

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = callback
      ? this.events[event].filter((cb) => cb !== callback)
      : [];
  }

  emit(event, ...args) {
    (this.events[event] || []).forEach((cb) => cb(...args));
  }

  once(event, callback) {
    const onceWrapper = (...args) => {
      callback(...args);
      this.off(event, onceWrapper);
    };
    this.on(event, onceWrapper);
  }
}

export default new PubSub();
